import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { type AISummary } from "@/shared/domain/ai_summary";

import { sessionQueryKeys } from "./sessionQueryKeys";

export interface UseGenerateSessionSummaryVariables {
  sessionId: string;
}

/**
 * Generate, or regenerate, a session's AI summary. The pending summary the
 * server answers with replaces the cached one, which starts
 * `useSessionSummary` polling.
 */
export function useGenerateSessionSummary() {
  const { sessionService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<AISummary, Error, UseGenerateSessionSummaryVariables>({
    mutationFn: ({ sessionId }) => sessionService.generateSummary(sessionId),
    onSuccess: (summary, { sessionId }) => {
      queryClient.setQueryData(sessionQueryKeys.summary(sessionId), summary);
    },
  });
}
